import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
import { InspectionSchema, InspectorRoleSchema } from '../entities/inspection.js';
export const StartInspectionPathRequestSchema = z.object({
    entityId: InspectionEntityCornSchema,
});
export const StartInspectionBodyRequestSchema = z.object({
    inspectionId: InspectionCornSchema.optional(),
    inspectorRole: InspectorRoleSchema.optional(),
    labels: z.array(z.string()).optional(),
    scheduledDate: z.iso.datetime().optional(),
});
export const StartInspectionResponseSchema = InspectionSchema;
export const StartInspectionApiSchema = {
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema,
    params: StartInspectionPathRequestSchema,
    body: StartInspectionBodyRequestSchema,
    response: StartInspectionResponseSchema,
};
export const StartInspectionRequestSchema = StartInspectionPathRequestSchema.extend(StartInspectionBodyRequestSchema.shape).extend(StartInspectionApiSchema.headers.shape);
